import React from 'react';
import Chart from 'react-apexcharts';
import './charts.css';
import './Indicateurs.css';

function PopChart({ series, height = 400, title = 'Évolution sur 10 ans', colors }) {
  // Générer les années de façon dynamique (dernière décennie)
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, i) => (currentYear - 9 + i).toString());

  // Utiliser une couleur unique (vert) si aucune couleur n'est spécifiée
  const chartColor = colors && colors.length > 0 ? colors[0] : 'var(--primary-green)';

  const defaultOptions = {
    chart: {
      type: 'bar',
      fontFamily: 'Montserrat, sans-serif',
      toolbar: {
        show: true,
        tools: {
          download: true,
          selection: false,
          zoom: false,
          zoomin: false,
          zoomout: false,
          pan: false,
          reset: false
        },
        export: {
          svg: {
            filename: 'evolution-graphique-svg'
          },
          png: {
            filename: 'evolution-graphique-png'
          }
        }
      },
      animations: {
        enabled: true,
        easing: 'easeinout',
        speed: 800,
        animateGradually: {
          enabled: true,
          delay: 150
        },
        dynamicAnimation: {
          enabled: true,
          speed: 350
        }
      }
    },
    xaxis: {
      // Utiliser les années générées dynamiquement au lieu de les calculer à partir des données
      categories: years,
      labels: {
        style: {
          colors: 'var(--secondary-green)',
          fontSize: '12px',
          fontFamily: 'Montserrat, sans-serif'
        },
        rotate: 0,
        hideOverlappingLabels: false,
        showDuplicates: false,
        trim: false
      },
      axisBorder: {
        show: true,
        color: '#e5e7eb'
      },
      axisTicks: {
        show: true,
        color: '#e5e7eb'
      },
      title: {
        text: "Années",
        style: {
          fontSize: '13px',
          fontWeight: 500,
          color: 'var(--secondary-green)'
        }
      }
    },
    yaxis: {
      labels: {
        style: {
          colors: 'var(--secondary-green)',
          fontSize: '12px',
          fontFamily: 'Montserrat, sans-serif'
        },
        formatter: function(val) {
          return val.toLocaleString();
        }
      },
      title: {
        text: "Valeurs",
        style: {
          fontSize: '13px',
          fontWeight: 500,
          color: 'var(--secondary-green)'
        }
      }
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '60%',
        borderRadius: 6,
        dataLabels: {
          position: 'top'
        }
      }
    },
    colors: [chartColor],
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'light',
        type: 'vertical',
        shadeIntensity: 0.2,
        gradientToColors: [chartColor],
        inverseColors: false,
        opacityFrom: 0.85,
        opacityTo: 0.95
      }
    },
    dataLabels: {
      enabled: true,
      offsetY: -30,
      style: {
        fontSize: '12px',
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: 600,
        colors: [chartColor]
      },
      formatter: function(val, opt) {
        return val.toLocaleString();
      }
    },
    grid: {
      borderColor: '#f3f4f6',
      strokeDashArray: 4,
      xaxis: {
        lines: {
          show: true
        }
      },
      yaxis: {
        lines: {
          show: true
        }
      }
    },
    tooltip: {
      enabled: true,
      theme: 'light',
      style: {
        fontSize: '13px',
        fontFamily: 'Montserrat, sans-serif'
      },
      y: {
        formatter: function(val) {
          return val.toLocaleString();
        }
      }
    },
    legend: {
      show: true,
      position: 'top',
      horizontalAlign: 'right',
      fontFamily: 'Montserrat, sans-serif',
      fontSize: '13px',
      offsetY: 0,
      markers: {
        width: 12,
        height: 12,
        radius: 6
      },
      itemMargin: {
        horizontal: 12
      },
      labels: {
        colors: 'var(--secondary-green)'
      }
    },
    responsive: [
      {
        breakpoint: 768,
        options: {
          plotOptions: {
            bar: {
              columnWidth: '80%'
            }
          },
          dataLabels: {
            offsetY: -20,
            style: {
              fontSize: '10px'
            }
          },
          legend: {
            position: 'bottom',
            horizontalAlign: 'center'
          }
        }
      }
    ]
  };

  return (
    <div className="gov-card gov-chart-bars">
      <div className="gov-card-body">
        <h5 className="gov-card-title">{title}</h5>
        <div style={{flex: 1, minHeight: '300px', position: 'relative'}}>
          <Chart
            options={defaultOptions}
            series={series}
            type="bar"
            width="100%"
            height={height}
          />
        </div>
      </div>
    </div>
  );
}

export default PopChart;

